module.exports = __webpack_public_path__ + "img/mouse.c6358630.svg";